import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const CONSENT_KEY = "l4_cookie_consent";
const LEMLIST_SRC =
  "https://app.lemlist.com/api/visitors/tracking?k=03VTfZdPXyx4fn1BaS2PE3SXW0LkTMlF7XbuONDG4pw%3D&t=tea_8gGMB7F3JZDSPTuov";

function loadLemlist() {
  if (document.getElementById("lemlist-tracking")) return;
  const s = document.createElement("script");
  s.id = "lemlist-tracking";
  s.type = "text/javascript";
  s.src = LEMLIST_SRC;
  document.body.appendChild(s);
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === "accepted") {
      loadLemlist();
    } else if (!consent) {
      setVisible(true);
    }
    const reopen = () => setVisible(true);
    window.addEventListener("l4-open-cookies", reopen);
    return () => window.removeEventListener("l4-open-cookies", reopen);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    loadLemlist();
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem(CONSENT_KEY, "refused");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-4 sm:p-6">
      <div className="mx-auto max-w-4xl rounded-2xl border border-white/10 bg-[#0f1e33]/95 backdrop-blur-md p-6 shadow-2xl">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#F5941E]/15 text-[#F5941E]">
            <Cookie size={22} />
          </div>
          <div className="flex-1">
            <div className="flex items-start justify-between gap-4">
              <h3 className="font-semibold text-white">Gestion des cookies</h3>
              <button
                onClick={refuse}
                className="text-slate-400 hover:text-white transition-colors"
                aria-label="Fermer"
              >
                <X size={18} />
              </button>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-slate-300">
              Nous utilisons uniquement les cookies nécessaires au fonctionnement
              du site. Avec votre accord, nous activons également un outil de
              mesure d'audience (lemlist) pour améliorer votre expérience. Vous
              pouvez accepter ou refuser, et modifier votre choix à tout moment.{" "}
              <Link
                to="/politique-cookies"
                onClick={() => setVisible(false)}
                className="text-[#F5941E] hover:underline"
              >
                En savoir plus
              </Link>
            </p>
            <div className="mt-4 flex flex-col sm:flex-row gap-3">
              <button
                onClick={accept}
                className="rounded-full bg-[#F5941E] hover:bg-[#e8850e] px-6 py-2.5 text-sm font-semibold text-white transition-colors"
              >
                Accepter
              </button>
              <button
                onClick={refuse}
                className="rounded-full border border-white/15 bg-white/5 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/10"
              >
                Refuser
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
